angular.module('app').controller('LoginSettingsCtrl',
    ['$scope', '$timeout', '$state', 'LanguageFactory', 'LocalStorageRepository', 'AprimaAnalytics', 'NotificationService', 'configuration',
        function ($scope, $timeout, $state, LanguageFactory, LocalStorageRepository, AprimaAnalytics, NotificationService, configuration) {
            'use strict';

            AprimaAnalytics.sendPageView('/Settings/User');

            $scope.values = {
                language: LanguageFactory.getLang().code
            };

            $scope.clientId = LocalStorageRepository.getClientID();
            $scope.notificationTimeout = LocalStorageRepository.getNotificationTimeout();
            $scope.isLanguageOpen = true;
            $scope.isApplicationInformationOpen = false;
            $scope.isOtherOpen = false;

            $scope.languages = LanguageFactory.getLangOptions;
            $scope.showDebugSettings = configuration.DEV_HOSTED;


            function getPrmAssemblyVersion() {
                return LocalStorageRepository.getPrmAssemblyVersion();
            }

            function clearClientId() {
                AprimaAnalytics.sendEvent('user', 'click', 'clear settings', 0);

                LocalStorageRepository.clearAll();

                var clientid = LocalStorageRepository.getClientID();

                if (!clientid) {
                    updateActionMessage('reset');
                } else {
                    updateActionMessage('failed');
                }
            }

            function backButton() {
                AprimaAnalytics.sendEvent('user', 'click', 'back button', 0);
                $state.go('login');
            }

            function changeLanguage() {
                AprimaAnalytics.sendEvent('user', 'click', 'change language', 0);
                LanguageFactory.setLang($scope.values.language);
                updateActionMessage($scope.values.language);
            }

           function changeClientId() {
                LocalStorageRepository.setClientID($scope.clientId);
                updateActionMessage($scope.clientId);
            }

            function changeNotificationTimeout() {
                var interval = $scope.notificationTimeout;
                if (interval >= 0 && interval <= 99) {
                    //if (interval == null) {
                    //    $scope.notificationTimeout = 0;
                    //}
                    LocalStorageRepository.setNotificationTimeout($scope.notificationTimeout);
                    updateActionMessage($scope.notificationTimeout);
                }

                NotificationService.stopNotificationTimer();
            }

            function updateActionMessage(status) {
                $scope.actionMessage = status;

                $timeout(function () {
                    $scope.actionMessage = '';
                }, 2500);
            }

            $scope.options = {
                selectedGroup: 'language'
            };

            $scope.backButton = backButton;
            $scope.changeLanguage = changeLanguage;
            $scope.clearClientId = clearClientId;
            $scope.getPrmAssemblyVersion = getPrmAssemblyVersion;

            if ($scope.showDebugSettings){
                $scope.changeNotificationTimeout = changeNotificationTimeout;
                $scope.changeClientId = changeClientId;
            }
        }]
);

